import ComponentMetricsBoundary from '@/components/ComponentMetricsBoundary/ComponentMetricsBoundary'
import CrossSell from '@/components/CrossSell/CrossSell'
import TripActivity from '@/components/TripActivity/TripActivity'

import type { SearchProductList } from '../TripActivity/types'
import GroupedTrip from './GroupedTrip'
import type { TripGrouping as TripGroupingProps } from './types'

export default function TripGrouping({
  tripGroupingBooking,
  tripGroupingAbandonedSelection,
  defaultAbandonedSelection,
  isLandingPage,
  growthLoopAudiences,
}: TripGroupingProps) {
  // Single flex item so HomeMobile's section gap doesn't also land between the trip card and Trip Activity
  const tripBlockClassName = 'flex flex-col gap-12 md:gap-8'
  // TODO: tidy up productType as part of WEB_HP_PACKAGE_SELECTIONS cleanup
  const tripActivityProductType = ['STAY', 'FLY', 'DRIVE', 'PKG'] as SearchProductList
  if (tripGroupingBooking) {
    if (tripGroupingAbandonedSelection) {
      return (
        <div className={tripBlockClassName}>
          <ComponentMetricsBoundary componentId='GroupedTrip'>
            <GroupedTrip
              isLandingPage={isLandingPage}
              booking={tripGroupingBooking}
              abandonedSelection={tripGroupingAbandonedSelection}
            />
          </ComponentMetricsBoundary>
          <TripActivity
            productType={tripActivityProductType}
            pageName='homepage'
            shouldUseSmallerHeading
            abandonedSelectionData={defaultAbandonedSelection}
            hideAbandonedSelection
          />
        </div>
      )
    }
    return (
      <div className={tripBlockClassName}>
        <ComponentMetricsBoundary componentId='CrossSell'>
          <CrossSell booking={tripGroupingBooking} growthLoopAudiences={growthLoopAudiences} />
        </ComponentMetricsBoundary>
        <TripActivity
          productType={tripActivityProductType}
          pageName='homepage'
          shouldUseSmallerHeading
          abandonedSelectionData={defaultAbandonedSelection}
          hideAbandonedSelection={false}
        />
      </div>
    )
  }

  return (
    <TripActivity
      productType={tripActivityProductType}
      pageName='homepage'
      shouldUseSmallerHeading={false}
      abandonedSelectionData={defaultAbandonedSelection}
      hideAbandonedSelection={Boolean(tripGroupingAbandonedSelection)}
    />
  )
}
